import { IsNumber } from 'class-validator';

export class GetDeliveryDistanceResponse {
    @IsNumber()
    public distance: number;

    constructor(data?: Partial<GetDeliveryDistanceResponse>) {
        this.distance = data?.distance;
    }
}
